import { computed } from 'vue'
import useStorage from '@nicolaudie-group/ng-ui-kit/composables/useStorage'
import createSharedComposable from '@nicolaudie-group/ng-ui-kit/helpers/createSharedComposable'
import config from '@/config'
import useDialog from '@/composables/useDialog'

/**
 * Simplify version by removing everything after minor.
 *
 * Used to avoid annoying users with unchanged release notes on every bugfix (patch version)
 *
 * @param {String} version Version number to simplify
 * @returns Simplified version
 */
function simplifyVersion(version) {
  return version.split('.').slice(0, 2).join('.')
}

function useReleaseNotes() {
  const lastViewedVersion = useStorage('last-viewed-release-notes', null)

  function setLastViewedVersion() {
    lastViewedVersion.value = simplifyVersion(config.version)
  }

  const {
    state: dialogState,
    control: dialogControl,
    open: openDialog,
    close: closeDialog,
  } = useDialog({
    initial: false,
    query: 'release-notes',
    onChange: (value) => {
      if (!value) {
        setLastViewedVersion()
      }
      return value
    },
  })

  const bannerState = computed(() => (
    lastViewedVersion.value !== simplifyVersion(config.version)
  ))

  function closeBanner() {
    /*
    Closing the dialog will trigger closing of the banner as "setLastViewedVersion" is called
    */
    closeDialog()
  }

  return {
    lastViewedVersion,
    version: config.version,
    dialogState,
    dialogControl,
    openDialog,
    closeDialog,
    bannerState,
    closeBanner,
  }
}

export default createSharedComposable(useReleaseNotes)
